export const GET_BOM_ADDITIONAL_CHARGES = 'GET_BOM_ADDITIONAL_CHARGES';
export const GET_BOM_ADDITIONAL_CHARGES_SUCCESS = 'GET_BOM_ADDITIONAL_CHARGES_SUCCESS';
export const GET_BOM_ADDITIONAL_CHARGES_FAILED = 'GET_BOM_ADDITIONAL_CHARGES_FAILED';

export const ADD_BOM_ADDITIONAL_CHARGES = 'ADD_BOM_ADDITIONAL_CHARGES';
export const ADD_BOM_ADDITIONAL_CHARGES_SUCCESS = 'ADD_BOM_ADDITIONAL_CHARGES_SUCCESS';
export const ADD_BOM_ADDITIONAL_CHARGES_FAILED = 'ADD_BOM_ADDITIONAL_CHARGES_FAILED';

export const UPDATE_BOM_ADDITIONAL_CHARGES = 'UPDATE_BOM_ADDITIONAL_CHARGES';
export const UPDATE_BOM_ADDITIONAL_CHARGES_SUCCESS = 'UPDATE_BOM_ADDITIONAL_CHARGES_SUCCESS';
export const UPDATE_BOM_ADDITIONAL_CHARGES_FAILED = 'UPDATE_BOM_ADDITIONAL_CHARGES_FAILED';

export const DELETE_BOM_ADDITIONAL_CHARGES = 'DELETE_BOM_ADDITIONAL_CHARGES';
export const DELETE_BOM_ADDITIONAL_CHARGES_SUCCESS = 'DELETE_BOM_ADDITIONAL_CHARGES_SUCCESS';
export const DELETE_BOM_ADDITIONAL_CHARGES_FAILED = 'DELETE_BOM_ADDITIONAL_CHARGES_FAILED'; 